/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_ExplainerInputs */

const en_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailor, cover letter, or interview prep uses 1 AI action. Job search, ATS scores, and salary data are always free.`)
};

const de_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Lebenslauf-Tailor, jedes Anschreiben oder jede Interview-Vorbereitung verbraucht 1 KI-Aktion. Jobsuche, ATS-Scores und Gehaltsdaten sind immer kostenlos.`)
};

const fr_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque adaptation de CV, lettre de motivation ou préparation d'entretien utilise 1 action IA. La recherche d'emploi, les scores ATS et les données salariales sont toujours gratuits.`)
};

const es_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada adaptación de currículum, carta de presentación o preparación de entrevista utiliza 1 acción IA. La búsqueda de empleo, puntuaciones ATS y datos salariales son siempre gratis.`)
};

const it_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni personalizzazione del curriculum, lettera di presentazione o preparazione al colloquio utilizza 1 azione AI. Ricerca di lavoro, punteggi ATS e dati salariali sono sempre gratuiti.`)
};

const nl_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk CV, sollicitatiebrief of interviewvoorbereiding gebruikt 1 AI-actie. Baanzoeken, ATS-scores en salarisgegevens zijn altijd gratis.`)
};

const pl_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każde dopasowanie CV, list motywacyjny lub przygotowanie do rozmowy kwalifikacyjnej wykorzystuje 1 akcję AI. Wyszukiwanie ofert pracy, wyniki ATS i dane dotyczące wynagrodzenia są zawsze darmowe.`)
};

const fi_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen ansioluettelon mukauttaminen, ansioluettelon mukauttaminen tai haastattelun valmistelu käyttää 1 AI-toimintoa. Työpaikan etsintä, ATS-pisteet ja palkkatiedot ovat aina ilmaisia.`)
};

const da_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver CV-tilpasning, ansøgningsbrev eller interviewforberedelse bruger 1 AI-handling. Jobsøgning, ATS-scores og løndata er altid gratis.`)
};

const sv_pricing_explainer = /** @type {(inputs: Pricing_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje CV-anpassning, ansökningsbrev eller intervjuförberedelse använder 1 AI-aktion. Jobbsökning, ATS-betyg och lönedata är alltid gratis.`)
};

/**
* | output |
* | --- |
* | "Each resume tailor, cover letter, or interview prep uses 1 AI action. Job search, ATS scores, and salary data are always free." |
*
* @param {Pricing_ExplainerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_explainer = /** @type {((inputs?: Pricing_ExplainerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_ExplainerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_explainer(inputs)
	if (locale === "fr") return fr_pricing_explainer(inputs)
	if (locale === "es") return es_pricing_explainer(inputs)
	if (locale === "it") return it_pricing_explainer(inputs)
	if (locale === "nl") return nl_pricing_explainer(inputs)
	if (locale === "pl") return pl_pricing_explainer(inputs)
	if (locale === "fi") return fi_pricing_explainer(inputs)
	if (locale === "da") return da_pricing_explainer(inputs)
	if (locale === "sv") return sv_pricing_explainer(inputs)
	return en_pricing_explainer(inputs)
});